export const optionType = [
  {
    key: 1,
    name: '登录'
  },
  {
    key: 2,
    name: '新增账号'
  },
  {
    key: 3,
    name: '修改账号'
  },
  {
    key: 4,
    name: '注销账号'
  },
  {
    key: 5,
    name: '新增角色'
  },
  {
    key: 6,
    name: '修改角色'
  },
  {
    key: 7,
    name: '删除角色'
  },
  {
    key: 8,
    name: '启用'
  },
  {
    key: 9,
    name: '停用'
  },
  {
    key: 10,
    name: '平台操作'
  },
  {
    key: 11,
    name: '权限变更'
  }
];

export const logType = {
  1: '登录',

  2: '新增账号',

  3: '修改账号',

  4: '注销账号',

  5: '新增角色',

  6: '修改角色',

  7: '删除角色',

  8: '启用',

  9: '停用',

  10: '平台操作',

  11: '权限变更'
};
